import React, { useEffect, useContext, useState } from 'react';
import { getFamilyList } from '../../../services/family';
import { Modal, Form, Button, Dimmer, Loader, Dropdown, Icon } from 'semantic-ui-react';
import UserContext from '../../../contexts/UserContext';
import './style.less';
import RedirectContext from '../../../contexts/RedirectContext';
import 'react-phone-number-input/style.css';
// import InviteModal from './inviteModal';
import { listResidentsInvites, resendInvite, removeInvite } from '../../../services/Invite';
import { toast } from 'react-toastify';
import config from '../../../config';
import { updateRelative } from '../../../services/family';
import { Steps, Hints } from 'intro.js-react';
import { getResidentAddressBookContacts, listResidentDevices } from '../../../services/messageRecipients'
import AddContactModal from './addContactModal'
import ChangeFriendlyNameModal from './changeFriendlyNameModal';

declare var process: {
    env: {
        SERVER_ENV: string;
    };
};

interface Contact {
    contactId: string;
    contactName: string;
}

interface Device {
    id: string;
    friendlyName: {
        type: string;
        value: {
            text: string;
        };
    };
    model: {
        type: string;
        value: {
            text: string;
        }
    };
    serialNumber: {
        type: string;
        value: {
            text: string;
        }
    };
}

const FamilyAndFriends = () => {

    const [isModalOpen, setIsModalOpen] = useState(false)
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
            profile: { _id: userId },
        },
    } = useContext(UserContext);
    const residentId = listOfResidents[activeRegistrantsIndexes] && listOfResidents[activeRegistrantsIndexes]._id;
    const [loadingContacts, setLoadingContacts] = useState(false);
    const [isFriendlyNameOpen, setIsFriendlyNameOpen] = useState(false);

    const [contactList, setContactList] = useState<Array<Contact>>([]);
    const [devicesList, setDevicesList] = useState<Array<Device>>([]);

    const reload = () => {
        setLoadingContacts(true);
        Promise.all([
            getResidentAddressBookContacts(residentId),
            listResidentDevices(residentId)
        ])
        .then(([response, endpoints])=> {
            console.log(response);
            setLoadingContacts(false);
            setContactList(response.contacts);
            console.log('end', endpoints)
            setDevicesList(endpoints);
        } )


        // getResidentAddressBookContacts(residentId)
        //     .then(response => {
        //     })
    } 

    useEffect(() => {
        console.log(residentId)
        reload()
    }, [residentId]);

    const toggleRedirect = useContext(RedirectContext);


    const navigate = (to: string) => {
        toggleRedirect(to);
        return;
    };

    return (
        <div>
            <div className="pb-70">
                <div className="relative-list">
                    {
                        loadingContacts ? (
                            <Dimmer className="pt-80" active={loadingContacts} inverted>
                                <Loader active={loadingContacts} />
                            </Dimmer>) :( 
                                <div>
                                <div className="resident-unit-devices">
                                    <div className="header">
                                        Devices
                                    </div>
                                    <div className="devices">
                                        {
                                            devicesList.map(device => (
                                                <div className="device">
                                                    <img  
                                                    className="device-image"
                                                    
                                                    src="/Alexa_Logo_RGB_BLUE.png"></img>
                                                    <div className="friendly-name"> 
                                                       Name: {device.friendlyName.value.text}
                                                    </div>

                                                    <div className="model-name">
                                                        Model Name: {device.model.value.text}
                                                    </div>

                                                    <div className="serial-number">
                                                       Serial ID:  {device.serialNumber.value.text}
                                                    </div>
                                                    {/* <Button
                                                        onClick={() => {
                                                            setIsFriendlyNameOpen(true)
                                                        }}
                                                    
                                                    >
                                                        Change Name (What your contacts will see)
                                                    </Button> */}
                                                    {
                                                    isFriendlyNameOpen && <ChangeFriendlyNameModal 
                isModalOpen={isFriendlyNameOpen}
                close={() => {
                    setIsFriendlyNameOpen(false);
                    reload();
                }}
                residentId={residentId}
                endpointId={device.id}                
                />
                

            
}
                                                </div>
                                            ))
                                        }                                        
                                    </div>



                                </div>
                            
                                {contactList.map(contact => (
                                    <div className="relative-info-container">
                                    <div
                                        className="relative-info"
                                        key={contact.contactId}
                                        role="link"
                                        onClick={() => navigate(`/message-recipients/${residentId}/address-book/contacts/${contact.contactId}`)}
                                    >

                                        <div className="relative-name-container">
                                            <p className="relative-name">{contact.contactName}</p>

                                        </div>
                                    </div>
                                </div>

                                ))
                                }
                                </div>

                                
                                )
                            

                        
                    }




                </div>

            </div>
            {
                isModalOpen && <AddContactModal
                    residentId={residentId}
                    isModalOpen={isModalOpen}
                    close={() => {
                        setIsModalOpen(false);
                    }}
                    reload={reload}

                />
            }
            <div className="buy-container">
                <Button

                    className="primary large bottom-invite-button"
                    onClick={() => {
                        console.log('open modal');
                        setIsModalOpen(true)
                    }}
                >
                    <i className="plus circle icon"></i> Add Contact
                </Button>
            </div>



        </div>
    );
};

export default FamilyAndFriends;
